import Member from "./Member";
import avatar1 from '../../assets/new-ui/vision/shark-label-1.gif'
import avatar2 from '../../assets/new-ui/vision/shark-label-2.gif'
import avatar3 from '../../assets/new-ui/vision/shark-label-3.gif'
import avatar4 from '../../assets/new-ui/vision/shark-label-4.gif'
export default function AboutUs() {
  return (
    <div className='aboutUs'>
      <div className='aboutUsRow'>
        <Member 
          avatar={avatar1} 
          name={'Aleksandr'} 
          job={'Lead of Developer'} 
          description={[
            'A Russian guy, a nerd, and a programmer. Aleksandr has a deep understanding of the Internet through online games. After graduation with a bachelor\'s degree in Computer Science from NUS, he applied for an internship in Singapore-based Google in the field of Machine Learning and AI. ',
            'Realizing the strong development of Blockchain, he quit his job after research and careful consideration and was a freelance full-time in this field. Author of many CEX exchanges and several marketplaces for NFT.'
          ]}
        />

        <Member 
          avatar={avatar2} 
          name={'Ritthirong'} 
          job={'Lead of Marketing'} 
          description={[
            'After graduating from university in Bangkok, he joined one of the top agencies responsible for launching several cosmetic and FMCG brands campaigns from many media channels. Ritthirong has four years of experience in participating in the cryptocurrency market. ',
            'One of the most achievements was in charge of an advertising campaign, which spread in 12 countries, with an estimated reach of over 500 million people. Currently, he is responsible for the marketing of the project.'
          ]}
        />
      </div>
      
      <div className='aboutUsRow'>
        <Member 
          avatar={avatar3} 
          name={'Jack'} 
          job={'Lead of Finance'} 
          description={[
            'After working as an employee at a large fund in Hong Kong specializing in infrastructure investment in developing countries, Jack has spent four years of experience as a personal financial advisor to many investors in the Fintech field.',
            'Moreover, he has broad knowledge in real estate, banking, technology, and currency. Since then, there have been many relationships with funds both in the blockchain and the traditional finance sides.'
          ]}
        />

        <Member 
          avatar={avatar4} 
          name={'Jenny'} 
          job={'Lead of Design'} 
          description={[
            'Starting out as an artist, before turning to product design and then graphics. Her team has participated in several Disney and Pixar projects and global agency as a character creator.',
            'Besides, in recent times Jenny also has many paintings designed as NFTs auctioned on the Ethereum platform and earned a profit of about $ 200k.'
          ]}
        />
      </div>
      
    </div>
  )
}